export default "__VITE_ASSET__B1b52cAq__"